import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./DownloadCard.module.css";
import { Link } from "@utrecht/component-library-react/dist/css-module";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
export const DownloadCard = _ref => {
  let {
    icon,
    label,
    sizeKb,
    layoutClassName,
    downloadLabel,
    handleClick
  } = _ref;
  return _jsxs("div", {
    className: clsx(styles.container, [layoutClassName && layoutClassName]),
    children: [_jsxs("div", {
      className: styles.content,
      children: [_jsx("div", {
        className: styles.icon,
        children: icon
      }), _jsxs("div", {
        children: [label, " (", sizeKb, "kb)"]
      })]
    }), _jsxs(Link, {
      onClick: handleClick,
      children: [_jsx(FontAwesomeIcon, {
        className: styles.icon,
        icon: faDownload
      }), " ", downloadLabel]
    })]
  });
};